import { render, staticRenderFns } from "./document-move-folder.vue?vue&type=template&id=31877643&scoped=true"
import script from "./document-move-folder.vue?vue&type=script&lang=js"
export * from "./document-move-folder.vue?vue&type=script&lang=js"
import style0 from "./document-move-folder.vue?vue&type=style&index=0&id=31877643&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31877643",
  null
  
)

export default component.exports